module.exports = "<button nbButton size=\"medium\"  (click)='descargarEntrada()' *ngIf=\"!esMoodle\"><i class=\"fas fa-file-download\"></i></button> "